// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Link } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import team3 from 'assets/img/gegee/avatar.png';
import Avatar from 'components/common/Avatar';

const ProfileDropdown = () => {
  return (
    <Dropdown navbar={true} as="li">
      <Dropdown.Toggle
        bsPrefix="toggle"
        as={Link}
        to="/"
        className="pe-0 ps-2 nav-link"
      >
        <Avatar src={team3} />
      </Dropdown.Toggle>

      <Dropdown.Menu
        className="dropdown-caret dropdown-menu-card  dropdown-menu-end"
        style={{ zIndex: '3' }}
      >
        <div className="bg-white rounded-2 py-2 dark__bg-1000">
          <Dropdown.Item as={Link} to="/customers/customer-settings">
            Профайл
          </Dropdown.Item>
          <Dropdown.Divider />
          {/* <Dropdown.Item href="#!">Зурвас</Dropdown.Item> */}
          <Dropdown.Item as={Link} to="/customers/customer-settings">
            Хувийн мэдээлэл
          </Dropdown.Item>
          {/* <Dropdown.Item href="#!">Нууц үг солих</Dropdown.Item> */}
          <Dropdown.Divider />
          <Dropdown.Item as={Link} to="/message/message-list">
            Зурвас
          </Dropdown.Item>
          <Dropdown.Item as={Link} to="/authentication/card/logout">
            Гарах
          </Dropdown.Item>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ProfileDropdown;
